import React from 'react'
import PropTypes from 'prop-types'

import {
  ThemeProvider,
  lightTheme,
  RateCardForm,
  RateCardTable,
  RateCardDefaultSettings,
  Grid
} from '@rodeo-dev/legos'
import {
  TIME_RATE_CARD,
  EXPENSE_RATE_CARD
} from '../../../../shared/constants.js'
import IntlUtil from '../../../lib/intlutil.jsx'
import Util from '../../../lib/util.jsx'
import app from '../../../app.jsx'

const FinanceTab = ({
  contactRateCards = [],
  globalRateCards = [],
  defaultRates = {},
  currencySymbol,
  onRateCardsSave,
  onDefaultsSave
}) => {
  const { decimalSeparator, thousandSeparator } = Util.getNumberInputSeparators(
    app.teamCountry
  )
  const inputsPropsObject = {
    markupInputProps: {
      decimalSeparator,
      thousandSeparator
    },
    rateInputProps: {
      fixedDecimalScale: true,
      decimalSeparator,
      thousandSeparator
    }
  }
  return (
    <ThemeProvider theme={lightTheme}>
      <Grid container spacing={4}>
        <Grid item sm={6}>
          <RateCardDefaultSettings
            title={IntlUtil.convertMessage('ratecard.form.defaultSettings')}
            onSave={onDefaultsSave}
            currencySymbol={currencySymbol}
            {...defaultRates}
            type='client'
            {...inputsPropsObject}
          />
        </Grid>
        <Grid item sm={12}>
          <Grid container spacing={4}>
            <Grid item sm={6}>
              <RateCardForm
                rates={contactRateCards.filter(
                  ({ type }) => type === TIME_RATE_CARD
                )}
                type={TIME_RATE_CARD}
                title={IntlUtil.convertMessage('ratecard.form.titleTime')}
                onSave={(newRateCards) =>
                  onRateCardsSave(newRateCards, TIME_RATE_CARD)}
                currencySymbol={currencySymbol}
                {...inputsPropsObject}
              />
            </Grid>
            <Grid item sm={6}>
              <RateCardTable
                type={TIME_RATE_CARD}
                title={IntlUtil.convertMessage('ratecard.form.titleTimeGlobal')}
                rates={globalRateCards.filter(
                  ({ type }) => type === TIME_RATE_CARD
                )}
                currencySymbol={currencySymbol}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item sm={12}>
          <Grid container spacing={4}>
            <Grid item sm={6}>
              <RateCardForm
                rates={contactRateCards.filter(
                  ({ type }) => type === EXPENSE_RATE_CARD
                )}
                type={EXPENSE_RATE_CARD}
                title={IntlUtil.convertMessage('ratecard.form.titleExpense')}
                onSave={(newRateCards) =>
                  onRateCardsSave(newRateCards, EXPENSE_RATE_CARD)}
                currencySymbol={currencySymbol}
                {...inputsPropsObject}
              />
            </Grid>
            <Grid item sm={6}>
              <RateCardTable
                type={EXPENSE_RATE_CARD}
                title={IntlUtil.convertMessage(
                  'ratecard.form.titleExpenseGlobal'
                )}
                rates={globalRateCards.filter(
                  ({ type }) => type === EXPENSE_RATE_CARD
                )}
                currencySymbol={currencySymbol}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ThemeProvider>
  )
}

export default FinanceTab

FinanceTab.propTypes = {
  contactRateCards: PropTypes.array.isRequired,
  globalRateCards: PropTypes.array.isRequired,
  defaultRates: PropTypes.shape({
    rate: PropTypes.number,
    rateMarkup: PropTypes.number,
    paymentDays: PropTypes.number
  }),
  currencySymbol: PropTypes.string.isRequired,
  onRateCardsSave: PropTypes.func.isRequired,
  onDefaultsSave: PropTypes.func.isRequired
}
